module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_flower-c32683831c6faed8f64aa5125bec23be.webp";